import React, { useState } from 'react';
import { Trash2, X } from 'lucide-react';
import { deleteReglaNivel, ReglaNivelUsuario } from '../../services/reglasNivelUsuariosService';

interface DeleteReglasNivelPageProps {
    regla: ReglaNivelUsuario;
    onClose: () => void;
    onDeleted: (deletedId: number) => void;
}

const DeleteReglasNivelPage: React.FC<DeleteReglasNivelPageProps> = ({ regla, onClose, onDeleted }) => {
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const handleDelete = async () => {
        setSubmitting(true);
        setError(null);
        try {
            await deleteReglaNivel(regla.id);
            onDeleted(regla.id);
            onClose();
        } catch (err: any) {
            setError(err.response?.data?.detail || 'Error al eliminar la regla de nivel');
            /* Browser diagnostics omitted. */
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
            <div className="bg-white p-8 rounded-2xl w-full max-w-md border border-gray-100 shadow-2xl relative">
                <div className="flex justify-between items-start mb-6">
                    <h3 className="text-[20px] font-bold text-gray-900">Confirmar eliminación</h3>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-600 transition-colors"
                    >
                        <X className="w-6 h-6" />
                    </button>
                </div>

                {error && (
                    <p className="mb-6 text-red-500 text-sm">{error}</p>
                )}

                <p className="mb-8 text-gray-600">
                    ¿Estás seguro que deseas eliminar la regla de nivel{' '}
                    <strong className="text-red-600">"{regla.nombre}"</strong>?
                </p>

                <div className="flex justify-end gap-3">
                    <button
                        onClick={onClose}
                        disabled={submitting}
                        className="px-5 py-2.5 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors duration-200 font-medium text-[14px]"
                    >
                        Cancelar
                    </button>
                    <button
                        onClick={handleDelete}
                        disabled={submitting}
                        className="px-5 py-2.5 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors duration-200 font-medium shadow-sm flex items-center text-[14px]"
                    >
                        <Trash2 className="w-4 h-4 mr-2" />
                        {submitting ? 'Eliminando...' : 'Eliminar'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteReglasNivelPage;